import React from 'react'
import { FormikFileSetField } from 'components/form/FileSetField'
import { FormikCheckboxField } from 'components/form/CheckboxField'

const OrderDeliveryNoteForm = ({ formik_props }) => {
  const canAutoCreateLineItems = formik_props?.values.delivery_note_format

  return(
    <>
    <FormikFileSetField
      name="delivery_notes"
      label={"delivery note"}
      formik_props={formik_props}
      preview_only_one_file_per_row
      file_types=".csv, .xlsx, .xls, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, .jpg, .png, .jpeg, .pdf"
    />
    { canAutoCreateLineItems &&
      <FormikCheckboxField
        name="delivery_note_auto_create_items"
        label="Auto create line items"
        formik_props={formik_props}
      />
    }
    </>
  )
}

export default OrderDeliveryNoteForm
